import React from "react";
import { translate } from "../../Services/translation";
const { compose, withProps, withStateHandlers } = require("recompose");
const { withScriptjs, withGoogleMap, GoogleMap, Marker } = require("react-google-maps");
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");

const StyledMapWithAnInfoBox = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBxYLDy8IZe-4HW-MFQJJStXFJX8i7q7cI&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `500px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withStateHandlers(
    () => ({
      isOpen: false,
      openInfoWindowMarkerId: "",
    }),
    {
      onToggleOpen: ({ isOpen }) => (markerId) => ({
        isOpen: !isOpen,
        openInfoWindowMarkerId: markerId,
      }),
    }
  ),

  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap defaultZoom={5} defaultCenter={{ lat: parseFloat(props.lat), lng: parseFloat(props.longt) }}>
    {props.reseller.items.length > 0 &&
      props.reseller.items.map((reseller, index) =>
        reseller.items.map((item, tindex) => (
          <Marker key={`MAP_${index}_${tindex}`} position={{ lat: parseFloat(item.Coordinates.split(",")[0]), lng: parseFloat(item.Coordinates.split(",")[1]) }} onClick={() => props.onToggleOpen(`${index}_${tindex}`)} key={index + "_" + tindex}>
            {props.isOpen && props.openInfoWindowMarkerId == `${index}_${tindex}` && (
              <InfoBox key={`MAPINFO_${index}_${tindex}`} onCloseClick={props.onToggleOpen} options={{ closeBoxURL: ``, enableEventPropagation: true }}>
                <div className="map-address">
                  <h3>{item.AgentName}</h3>
                  <p>{item.Address}</p>
                  <p>
                    <a href={"mailto:" + item.Email}>{item.Email}</a>
                  </p>
                  <p>
                    <a href={"tel:" + item.Phone}>{item.Phone}</a>
                  </p>
                  {item.ResellerWebsiteUrl && item.ResellerWebsiteUrl.length >0 && 
                      <p>
                        <a href={item.ResellerWebsiteUrl} target="_blank">{item.ResellerWebsiteUrl}</a>
                      </p>
                  }
                </div>
              </InfoBox>
            )}
          </Marker>
        ))
      )}
  </GoogleMap>
));

export default StyledMapWithAnInfoBox;
